<!-- 网站首页 -->
<template>
  <div>
    <transition name="el-fade-in"><img class="bg_000000" :style="{ width, heght }" v-show="is_show" @load="img_back"  :src="src" alt="" /></transition>
  </div>
</template>
<script>
export default {
  data() {
    return {
      is_show: false
    };
  },
  props: {
    width: {
      type: String,
      default: '100%'
    },
    heght: {
      type: String,
      default: 'auto'
    },
    src: {
      type: String,
      default: ''
    }
  },
  methods: {
    img_back(e) {
      //console.log(e)
      this.is_show = true;
    }
  }
};
</script>

<style scoped="scoped"></style>



// WEBPACK FOOTER //
// src/components/public-img/public-img.vue